<soft-ds-card density="none">
  <cdk-accordion>
    @if (data()?.itemVkforg; as vkforgs) {
    <cdk-accordion-item
      #accordionItem="cdkAccordionItem"
      [expanded]="expanded()"
      [attr.aria-expanded]="accordionItem.expanded"
      class="flex flex-col"
    >
      <div
        class="font-semibold flex justify-between items-center cursor-pointer p-4"
        role="button"
        tabindex="0"
        (click)="accordionItem.toggle()"
        (keydown.enter)="accordionItem.toggle()"
        (keydown.space)="$event.preventDefault(); accordionItem.toggle()"
      >
        <div class="flex items-center gap-2">
          <h6
            class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide"
          >
            {{ '#ARTIKELINFO.PAGES.DETAIL.VKFORG.LISTUNG' | translate }}
          </h6>
          <soft-ds-badge size="md" variant="outline">{{ vkforgs.length }}</soft-ds-badge>
        </div>
        <div class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover">
          @if (!accordionItem.expanded) {
          <soft-icon name="fa-regular fa-chevron-down" />
          } @if (accordionItem.expanded) {
          <soft-icon name="fa-regular fa-chevron-up" />
          }
        </div>
      </div>
      <div [style.display]="accordionItem.expanded ? 'block' : 'none'" class="bg-surface">
        <section class="flex flex-wrap gap-2 px-3 pb-2 md:hidden">
          @for (listing of listings(); track listing.kzgelistet) {
          <div class="flex items-center gap-1.5">
            <soft-ds-badge variant="secondary" size="lg">
              {{ listing.kzgelistet }}
            </soft-ds-badge>
            <span class="text-xs md:text-sm text-light">{{ listing.title }}</span>
          </div>
          }
        </section>
        <div
          class="flex px-4 py-2 items-center justify-between w-full border-b border-b-solid border-b-separator border-t border-t-solid border-t-separator bg-surface-tertiary"
        >
          <div class="text-xs font-semibold text-light uppercase">
            {{ '#ARTIKELINFO.PAGES.DETAIL.VKFORG.VKFORG' | translate }}
          </div>
          <div class="text-xs font-semibold text-light uppercase text-right">
            {{ '#ARTIKELINFO.PAGES.DETAIL.VKFORG.LISTUNG' | translate }}
          </div>
        </div>
        @for (vkforg of vkforgs; track vkforg) {
        <div
          class="flex px-4 py-3 items-center justify-between w-full border-b border-b-solid border-b-separator"
        >
          <div class="text-sm md:text-base">{{ vkforg.vkforg?.vkforg }}</div>
          <soft-ds-badge variant="secondary" size="lg">
            <span class="md:hidden">{{ vkforg.listing.kzgelistet }}</span>
            <span class="hidden md:inline">
              {{ vkforg.listing.kzgelistet }} - {{ vkforg.listing.title }}
            </span>
          </soft-ds-badge>
        </div>
        }
      </div>
    </cdk-accordion-item>
    }
  </cdk-accordion>
</soft-ds-card>
